import React from 'react';
import { BookOpenIcon, CheckSquareIcon, BookmarkIcon } from 'lucide-react';
const steps = [{
  numeral: '1',
  Icon: BookOpenIcon,
  title: 'Open the month you’re living',
  body: 'It’s month seven? That’s Volume Three. Nothing from any other phase comes with you.'
}, {
  numeral: '2',
  Icon: CheckSquareIcon,
  title: 'Do the three tasks that are due',
  body: 'This month’s budget lines, bookings and decisions — with the numbers already done for you.'
}, {
  numeral: '3',
  Icon: BookmarkIcon,
  title: 'Close the book',
  body: 'The month is closed, so you’re not behind. By definition. The rest of the week is yours.'
}];
export function MonthInPractice() {
  return <section aria-labelledby="month-heading" className="w-full bg-ivory" data-id="element-133" data-mp="2cvu2bcuvvghn">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-134" data-mp="16hcksdwav4kc">
        <p className="text-center text-[13px] font-semibold uppercase tracking-kicker text-sage-deep" data-id="element-135" data-mp="16ego0sw6ulxh">
          What a month looks like
        </p>
        <h2 id="month-heading" className="mt-4 font-serif font-normal text-ink text-[28px] leading-tight sm:text-[38px] text-center" data-id="element-136" data-mp="2x2460jp0vj1j">
          Twenty minutes on a Sunday. That&apos;s the whole system.
        </h2>
        <div className="mx-auto mt-6 h-px w-32 bg-sage/40" aria-hidden="true" data-id="element-137" data-mp="2o2peri1174fz" />

        <ol className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-id="element-138" data-mp="2sxmnenuefbsc">
          {steps.map(({
          numeral,
          Icon,
          title,
          body
        }) => <li key={numeral} className="flex flex-col" data-id="element-139" data-mp="2j104i4lmuusy">
              <div className="flex items-center gap-3" data-id="element-140" data-mp="2j2kz1u7y6dqt">
                <span className="font-serif font-normal text-sage-deep text-[52px] leading-none" aria-hidden="true" data-id="element-141" data-mp="25ao8vvpuadx2">
                  {numeral}
                </span>
                <Icon className="w-5 h-5 text-sage" strokeWidth={1.25} aria-hidden="true" data-id="element-142" data-mp="1vd0b0wwxsqao" />
              </div>
              <h3 className="mt-5 font-serif font-medium text-ink text-[21px] leading-snug" data-id="element-143" data-mp="5utnv52qv8tf">
                {title}
              </h3>
              <p className="mt-3 text-[17px] leading-[1.6] text-ink-soft" data-id="element-144" data-mp="12k5qb7vfd1p">
                {body}
              </p>
            </li>)}
        </ol>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif italic text-ink text-[19px] leading-relaxed sm:text-[22px]" data-id="element-145" data-mp="3o9ceurmn72gp">
          &ldquo;It&apos;s Sunday, month seven. Dress fitting booked, stationery
          shortlist done, tasting confirmed. You close the book. That&apos;s
          it.&rdquo;
        </p>
      </div>
    </section>;
}